import { UserPlus, Users } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

import { API_URL, apiFetch } from '../../config/api';
interface Member { id: number; user_id: number; agent_id?: number; display_name?: string; agent_name?: string; role: string; joined_at: string }
interface ProjectMembersProps { projectId: number; isResearch?: boolean }

export default function ProjectMembers({ projectId, isResearch }: ProjectMembersProps) {
  const [members, setMembers] = useState<Member[]>([])
  const [loading, setLoading] = useState(true)
  const [joining, setJoining] = useState(false)
  const { user } = useAuth()

  useEffect(() => {
    const loadMembers = async () => {
      try {
        const res = await fetch(isResearch ? `${API_URL}/api/research/projects/${projectId}/members` : `${API_URL}/api/projects/${projectId}/members`)
        const data = await res.json()
        const mems = data.members as Member[]
        setMembers(mems || [])
      } catch (err) {
        console.error('Members load error:', err)
      } finally {
        setLoading(false)
      }
    }
    void loadMembers()
  }, [projectId])

  const handleJoin = async () => {
    if (!user?.id) return
    setJoining(true)
    try {
      const res = await apiFetch(`${API_URL}/api/research/projects/${projectId}/participants/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id, role: 'contributor' }),
      })
      if (res.ok) {
        setMembers(prev => [...prev, { id: Date.now(), user_id: Number(user.id), display_name: user.display_name || 'You', role: 'contributor', joined_at: new Date().toISOString() }])
      }
    } catch {} finally { setJoining(false) }
  }

  const alreadyMember = members.some(m => user?.id && String(m.user_id) === String(user.id))

  useEffect(() => {
    const loadMembers = async () => {
      try {
        const res = await fetch(isResearch ? `${API_URL}/api/research/projects/${projectId}/members` : `${API_URL}/api/projects/${projectId}/members`)
        const data = await res.json()
        const mems = data.members as Member[]
        setMembers(mems || [])
      } catch (err) {
        console.error('Members load error:', err)
      } finally {
        setLoading(false)
      }
    }
    void loadMembers()
  }, [projectId])

  if (loading) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
  }

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <h2 style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: 0 }}>
          <Users size={24} /> Members ({members.length})
        </h2>
        {isResearch && !alreadyMember && user && (
          <button onClick={() => { void handleJoin() }} disabled={joining} style={{
            display: 'flex', alignItems: 'center', gap: 6, padding: '8px 16px', borderRadius: 8,
            background: '#667eea', border: 'none', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}>
            <UserPlus size={14} /> {joining ? 'Joining...' : 'Join as Contributor'}
          </button>
        )}
        {alreadyMember && (
          <span style={{ fontSize: 12, color: '#10b981', fontWeight: 600 }}>✅ You're a member</span>
        )}
      </div>
      {members.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-tertiary)' }}>
          <Users size={64} style={{ opacity: 0.5, marginBottom: '16px' }} />
          <h3>No members yet</h3>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px' }}>
          {members.map(member => (
            <div key={member.id} style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'linear-gradient(135deg, #667eea, #764ba2)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: '700', fontSize: '18px' }}>
                {(member.display_name || member.agent_name || 'Unknown').charAt(0).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>{member.display_name || member.agent_name || 'Unknown'}</div>
                <div style={{ fontSize: '13px', color: 'var(--text-tertiary)' }}>{member.role}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
